const Footer = ({ bgColor = "white", color = "#111729" }) => {
  return (
    <footer
      className="w-full flex flex-row py-2 text-[9px] sm:text-footerFontSize mt-1 items-center justify-center z-20"
      style={{ backgroundColor: bgColor }}
    >
      <div className="text-center" style={{ color }}>
        ©{" "}
        {new Date().getFullYear() > 2026
          ? `2026-${new Date().getFullYear()}`
          : "2026"}
        , Needles and Haystacks Technology Pvt Ltd.
      </div>
    </footer>
  );
};
export default Footer;
